export const hzscbRoute = [
  //记录列表
  {
    path: '/hzscb',
    component: () => import('./views/hzscb')
  },
  //选择科室
  {
    path: '/hzscb/dept',
    component: () => import('./views/dept')
  },
  //提交
  {
    path: '/hzscb/paper',
    component: () => import('./views/paper')
  },
  //记录详情
  {
    path: '/hzscb/record',
    component: () => import('./views/record')
  }
]



// WEBPACK FOOTER //
// ./src/page/hzscb/route.js